import service from '../service/balance'
import CONSTANT from '../constant/balance'
import _ from 'underscore'
export default {
    getBalanceRecord ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getBalanceRecord(data).then(result => {
                resolve(result)
                commit(CONSTANT.BALANCE_GETBALANCERECORD_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BALANCE_GETBALANCERECORD_ERROR, e)
            })
        })
    },
    getUserBalance ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getUserBalance(data).then(result => {
                resolve(result)
                commit(CONSTANT.BALANCE_GETUSERBALANCE_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BALANCE_GETUSERBALANCE_ERROR, e)
            })
        })
    },
    getBalanceRecordDetail ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getBalanceRecordDetail(data).then(result => {
                resolve(result)
                commit(CONSTANT.BALANCE_GETBALANCERECORDDETAIL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BALANCE_GETBALANCERECORDDETAIL_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}